export enum OtherCustomQuotationTypeEnum {
  SOUS_DOUANE = "SOUS_DOUANE",
  DAE = "DAE",
  RP_FISC_PART = "RP_FISC_PART",
  RP_FISC_PRO = "RP_FISC_PRO",
  T1_T2 = "T1_T2",
  RFSE = "RFSE",
  DEFAULT = "DEFAULT",
}
